
const setConfigClass = (customerConfig) => {
  if(customerConfig.withOrder) {
    document.querySelector('html').classList.add('miam-withOrder');
  }else{
    document.querySelector('html').classList.add('miam-withoutOrder');
  }
};
export default setConfigClass;
